const COLORMAP = {
    youtubeRed: '#C4302B',
    borderColor: '#DFDFDF',
    tabBorderBottomColor: '#E2E2E2'
};

export default COLORMAP;
